<template>
  <div class="sel-role-wrapper">
    <!--    <vue-qr v-show="erCode" backgroundColor="#fff" class="er-code" :logoSrc="logo" :text="erCode" :size="180"></vue-qr>-->
    <div class="center-bg-wrapper">
      <!--  -->
      <img
        class="center-bg-img"
        :src="require('../../assets/imgs/family/parent-bg.png')"
        @click="this.action_selectParent"
      />
    </div>
    <div class="center-bg-wrapper">
      <!--  -->
      <img
        class="center-bg-img"
        :src="require('../../assets/imgs/family/child-bg.png')"
        @click="this.action_selectChild"
      />
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { getQrcode, getRecognize } from "@/api/user";
import QRCode from "qrcode";
import { wxConfigWXApi } from "@/lib/wxShare";

export default {
  name: "SelRole",
  data() {
    return {
      erCode: "",
      logo: this.$store.state.user.userInfo.headImageUrl,
    };
  },

  components: {},

  activated() {

  },

  mounted() {},

  methods: {
    //===============action==================
    //选择孩子
    action_selectChild() {
        this.$router.push({path: '/bindParent'})
    },

    //选择家长父母
    action_selectParent() {
        this.$router.push({path: '/bindChild'})

    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.sel-role-wrapper {
  text-align: center;
}

.center-bg-wrapper {
  padding: 0 30px;
  margin-top: 30px;
}

.center-bg-img {
  width: 100%;
}

.my-code-text {
  margin-top: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.code-input-wrapper {
  border: 1px solid #3994E7;
  margin: auto 28px;
  margin-top: 30px;
  line-height: 44px;
  border-radius: 22px;
}

.code-input {
  margin-left: 20px;
  line-height: 44px;
  width: 100%;
  background-color: #00000000;
}

.title {
  font-size: 17px;
  margin-top: 30px;
}

.er-code {
  margin-top: 10px;
  padding: 2px;
  width: 200px !important;
  height: 200px !important;
}

.learn-flow-btn {
  display: block;
  margin: 20px auto;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// app/pages/family/RoleSelect.vue